import type { GoodsCoreModel, IScreensLogging } from '../../../../../api/types';
import { bridge, isNotNil } from '../../../../../utils';
import { AdAction } from '../../../../../utils/eventLogger/adLogger/types';

type LogOnGoodsPressItemProps = {
  logging: IScreensLogging;
  item: GoodsCoreModel;
};

export const logOnGoodsPressItem = ({
  logging,
  item,
}: LogOnGoodsPressItemProps) => {
  bridge.logAnalyticsEvent({
    channel: ['firebase', 'amplitude', 'ablylog', 'facebook'],
    name: 'CLICK_GOODS',
    analytics: logging.analytics,
    ably_only_log: logging.ably_only_log,
  });
  if (isNotNil(item.ad)) {
    bridge.logAdEvent({ action: AdAction.CLICK, ad: item.ad });
  }
};
